import React, { useEffect, useRef } from 'react';

// Classic Windows right-click context menu
// items: [{ label, accel?, onClick?, disabled?, separator?, icon?, submenu? }]
const ContextMenu = ({ x, y, items, onClose }) => {
  const ref = useRef(null);

  useEffect(() => {
    const onDocClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    };
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('mousedown', onDocClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDocClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [onClose]);

  // Clamp to viewport
  const maxX = window.innerWidth - 230;
  const maxY = window.innerHeight - items.length * 22 - 20;
  const px = Math.min(x, maxX);
  const py = Math.min(y, maxY);

  return (
    <div
      ref={ref}
      className="fixed z-[100] bg-[#F5F5F5] border border-[#858585] shadow-lg py-[2px] text-[12px]"
      style={{
        left: px,
        top: py,
        minWidth: 220,
        fontFamily: 'Tahoma, Segoe UI, sans-serif',
        boxShadow: '2px 2px 6px rgba(0,0,0,0.25)',
      }}
    >
      {items.map((item, i) => {
        if (item.separator) {
          return <div key={i} className="h-[1px] bg-[#C0C0C0] my-[2px] mx-[4px]" />;
        }
        const handleClick = () => {
          if (item.disabled) return;
          if (item.onClick) item.onClick();
          onClose();
        };
        return (
          <div
            key={i}
            onClick={handleClick}
            className={`flex items-center h-[22px] px-[8px] cursor-default ${
              item.disabled ? 'text-[#999]' : 'text-black hover:bg-[#2B579A] hover:text-white'
            }`}
          >
            <div className="w-[16px] mr-[8px] flex items-center justify-center">{item.icon || null}</div>
            <div className="flex-1">{item.label}</div>
            {item.submenu && <span className="ml-[10px]">\u25b6</span>}
            {item.accel && <span className="ml-[16px] text-[11px] opacity-70">{item.accel}</span>}
          </div>
        );
      })}
    </div>
  );
};

export default ContextMenu;
